import React, { Component } from 'react';
import PropTypes from 'prop-types';
import FormattedCurrencyNumberCustom from '../../formatted-currency-number-custom';
import AvailableBalanceDetails from './available-balance-details';
import config from '../../../../src/globs/config';

class FrCMBalanceDetails extends Component {
  constructor(props) {
    super(props);
    this.state = {
      showAvailableBalancePopUp: false,
      showMainLoader: true,
    };
  }

  componentDidMount() {
    const { props } = this;
    const path = `${config.apiContextPath}/sales_officers/${props.user.id}/businesses/${props.match.params.customerId}/fetch_balance`;
    props.dataLoad({
      key: 'balance',
      url: path,
    });
  }

  componentDidUpdate(prevProps, prevState) {
    // Only update when API status changes from PENDING to complete/rejected
    // Prevent infinite loops in React 19
    if (prevProps.ajaxStatuses.balance === 'PENDING' &&
      (this.props.ajaxStatuses.balance === '' || this.props.ajaxStatuses.balance === 'REJECTED')) {
      // Only update if showMainLoader needs to change
      if (this.state.showMainLoader !== false) {
        this.setState({
          showMainLoader: false,
        });
      }
    }
  }
  closeOkPopUp = () => {
    console.log('umesh============>');
    this.setState({
      showAvailableBalancePopUp: false,
    });
  };

  render() {
    console.log('props =============>', this.props.balance);
    const saleOrderNotInvoied = this.props.balance.sales_orders_not_invoiced ?
      (this.props.balance.sales_orders_not_invoiced *
        (1 + (this.props.balance.tax_rate / 100))) : 0;
    return (
      <div>
        {!(this.state.showMainLoader) &&
          <div>
            {this.state.showAvailableBalancePopUp &&
              <AvailableBalanceDetails user={this.props.balance} okButtonClick={this.closeOkPopUp} />
            }
            <div className="filter-pop zambia-balance-detail-pop">
              <div className="lr-make-sale lr-overlay">
                <div className="lr-overlay__header">
                  <div className="lr-overlay__header-title">
                    <button type="button" className="lr-overlay__header-back-button" onClick={this.props.backButtonClick}>
                      <i className="icon-back" />
                    </button>
                    Balance Details
                  </div>
                </div>
                <div className="lr-overlay__body order-detail">
                  <div className="filter-content">
                    <p className="balance-detail-text">Payment term: {this.props.balance.payment_terms}</p>
                    <div className="zambia-balance-detail">
                      <p className="balance-detail-text">Available Balance<i className="icon-info" onClick={() => { this.setState({ showAvailableBalancePopUp: true }); }} /></p>
                      {/* <p className="balance-detail-text">Outstanding Payments</p> */}
                    </div>
                    <div className="zambia-balance-detail">
                      <div className="balance-detail-amount-container">
                        <span className="balance-detail-amount" style={{ color: (this.props.balance.removal_capacity < 0) ? 'red' : '' }}>
                          <FormattedCurrencyNumberCustom value={
                            this.props.balance.removal_capacity ?
                              this.props.balance.removal_capacity : 0
                          }
                          />
                        </span>
                        <p className="balance-calc">( A-B-C-D-E ) </p>
                      </div>
                      {/* <div className="balance-detail-amount-container-2">
                      <span className="balance-detail-amount">
                        <FormattedCurrencyNumberCustom value={
                          this.props.balance.outstanding_payment ?
                          this.props.balance.outstanding_payment : 0
                        }
                        />
                      </span>
                      <p className="balance-calc2">( B + C + D ) </p>
                    </div> */}
                    </div>
                    <div className="triangle-down" />
                    <div className="zambia-balance-alldetail-container">
                      <div className="zambia-balance-alldetail">
                        <p>A. Credit Limit</p>
                        <p>
                          <FormattedCurrencyNumberCustom value={
                            this.props.balance.credit_limit ?
                              this.props.balance.credit_limit : 0
                          }
                          /></p>
                      </div>
                      <div className="zambia-balance-alldetail">
                        <p>B. Accounting Balance</p>
                        <p>
                          <FormattedCurrencyNumberCustom value={
                            this.props.balance.outstanding_payment ?
                              this.props.balance.outstanding_payment : 0
                          }
                          /></p>
                      </div>
                      <div className="zambia-balance-alldetail">
                        <p>C. Open Sales Order Amount</p>
                        <p>
                          <FormattedCurrencyNumberCustom value={Math.round(saleOrderNotInvoied)} />
                        </p>
                      </div>
                      <div className="zambia-balance-alldetail">
                        <p>D. Open Credit Order Amount</p>
                        <p>
                          <FormattedCurrencyNumberCustom value={(this.props.balance.credit_note *
                            (1 + (this.props.balance.tax_rate / 100)))}
                          /></p>
                      </div>
                      <div className="zambia-balance-alldetail">
                        <p>E. Open Debit Order Amount</p>
                        <p>
                          <FormattedCurrencyNumberCustom value={
                            (this.props.balance.debit_note *
                              (1 + (this.props.balance.tax_rate / 100)))}
                          /></p>
                      </div>
                    </div>
                    <div className="zambia-balance-detail">
                      <p className="balance-detail-text amount-owing"><i className="icon-info icon-info2" onClick={() => { this.setState({ showAvailableBalancePopUp: true }); }} />Amount owed between 1-30 days</p>
                      <p className="balance-detail-text2">Over 30 days</p>
                    </div>
                    <div className="zambia-balance-detail">
                      <div className="balance-detail-amount-container">
                        <p className="balance-detail-amount">
                          <FormattedCurrencyNumberCustom value={
                            this.props.balance.invoiced_amount_from_1_to_30_days ?
                              this.props.balance.invoiced_amount_from_1_to_30_days : 0
                          }
                          /></p>
                      </div>
                      <div className="balance-detail-amount-container-2">
                        <p className="balance-detail-amount">
                          <FormattedCurrencyNumberCustom value={
                            this.props.balance.invoiced_amount_above_30_days ?
                              this.props.balance.invoiced_amount_above_30_days : 0
                          }
                          /></p>
                      </div>
                    </div>
                  </div>
                </div>
              </div>
            </div>
          </div>
        }
      </div>
    );
  }
}

FrCMBalanceDetails.propTypes = {
  user: PropTypes.shape({
    removal_capacity: PropTypes.node,
    payment_terms: PropTypes.string,
    outstanding_payment: PropTypes.node,
    credit_limit: PropTypes.node,
    tax_rate: PropTypes.node,
    debit_note: PropTypes.node,
    credit_note: PropTypes.node,
    sales_orders_not_invoiced: PropTypes.node,
    invoiced_amount_not_yet_paid: PropTypes.node,
    orders_not_invoiced_price: PropTypes.node,
    invoiced_amount_from_1_to_30_days: PropTypes.node,
    invoiced_amount_above_30_days: PropTypes.node,
  }),
  ajaxDataLoadStatuses: PropTypes.shape({
    fetchBalanceFromSap: PropTypes.string,
  }),
  backButtonClick: PropTypes.func,
};

FrCMBalanceDetails.defaultProps = {
  user: {},
  backButtonClick: {},
  ajaxDataLoadStatuses: undefined,
};

export default FrCMBalanceDetails;
